export const isSmall = () => {
    return window.innerWidth < 900;
};
